import { render, staticRenderFns } from "./ElFormSmallItem.vue?vue&type=template&id=0714ac72"
import script from "./ElFormSmallItem.vue?vue&type=script&lang=js"
export * from "./ElFormSmallItem.vue?vue&type=script&lang=js"
import style0 from "./ElFormSmallItem.vue?vue&type=style&index=0&id=0714ac72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports